import React from 'react'
import { useParams } from 'react-router-dom'
import { PageLink as Link } from 'src/app/AppAuth/PageLink'
import { EvidenceAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useEvidenceGroupIfExists } from 'src/pages/Evidence/evidence.hooks'
import { SubjectContainer } from './Subject.styles'

export const EvidenceContent = ({
  evidenceId,
  caption,
}: {
  evidenceId: string
  caption?: string
}): JSX.Element => {
  const { pageContext } = useParams()
  const { data, isLoading } = useEvidenceGroupIfExists(evidenceId)
  const evidenceExists = data?.getExists()
  if (!evidenceId || !evidenceExists) {
    return caption ? (
      <SubjectContainer>
        <span>{`\u2022`}</span>
        {caption}
      </SubjectContainer>
    ) : !evidenceExists ? (
      <SubjectContainer>
        <span>{`\u2022`}</span>
        (Deleted)
      </SubjectContainer>
    ) : (
      <></>
    )
  }

  const evidence = data?.getEvidenceGroup()
  if (!caption || isLoading || !data) {
    return <></>
  }
  const url = `/${pageContext}/${
    EvidenceAbsoluteRoutes.SHOW
  }/${encodeURIComponent(evidenceId)}`

  const docExists = !!evidence?.getId()

  return (
    <SubjectContainer>
      <span>{`\u2022`}</span>
      {docExists ? <Link to={url}>{caption}</Link> : <>{caption}</>}
    </SubjectContainer>
  )
}
